import { ValidationOptions, ValidationResult, ObjectSchema } from '@hapi/joi';

function errorDict(validationResult: ValidationResult) {
  return validationResult.error?.details
    ?.map(({ path, message }) => ({
      key: path[0],
      message,
    }))
    .reduce((obj, errObj) => ({ ...obj, [errObj.key]: errObj.message }), {});
}

function errorDictForNestedValue(validationResult: ValidationResult) {
  return validationResult.error?.details
    ?.map(({ context, message, path }) => ({
      key: context?.label || '', // we should always have context?.label
      message,
      path,
    }))
    .reduce((obj, errObj) => ({ ...obj, [errObj?.key]: { message: errObj.message, path: errObj.path } }), {});
}

// https://hapi.dev/family/joi/api/?v=17.1.0#anyvalidatevalue-options
const DEFAULT_OPTS: ValidationOptions = {
  abortEarly: false,
  allowUnknown: true,
};

export default function validate<V>(schema: ObjectSchema, value: V, options: ValidationOptions, isNestedValue = false) {
  if (isNestedValue) {
    return errorDictForNestedValue(schema.validate(value, { ...DEFAULT_OPTS, ...options }));
  }
  return errorDict(schema.validate(value, { ...DEFAULT_OPTS, ...options }));
}
